export const updateFilterType = (filterType) => {
  return {
    type: "UPDATE_FILTER_TYPE",
    payload: filterType,
  };
};
export const updateFilterPercentage = (filterPercent) => {
  return {
    type: "UPDATE_FILTER_PERCENTAGE",
    payload: filterPercent,
  };
};

export const updateFilterData = (data) => {
  return {
    type: "UPDATE_FILTER_DATA",
    payload: data,
  };
};

export const updateCityData = (data) => {
  console.log("function called", data);
  return {
    type: "UPDATE_CITY_DATA",
    payload: data,
  };
};

export const updateCloseAirbnbData = (data) => {
  console.log("function called", data);
  return {
    type: "UPDATE_CLOSE_AIRBNB_DATA",
    payload: data,
  };
};

export const resetMarketData = () => {
  return {
    type: "RESET_MARKET_DATA",
  };
};
